<template>
  <v-btn
    type="button"
    :color="color"
    depressed
    :loading="isLoading"
    :outlined="outlined"
    @click.prevent="_onClick()"
    :block="block"
    :height="height"
    :min-height="height"
    :disabled="disabled"
    :small="small"
  >
    <v-icon v-if="isAdd" class="fi fi-rr-add mr-3" small></v-icon>
    <slot name="prepend"></slot>
    {{ $t(text) }}
    <slot name="append"></slot>
  </v-btn>
</template>

<script>
export default {
  name: 'FormButton',
  props: {
    color: {
      type: String,
      default: 'primary',
      required: false,
    },
    loading: {
      type: Boolean,
      default: false,
      required: false,
    },
    text: {
      type: String,
      default: 'save',
      required: false,
    },
    outlined: {
      type: Boolean,
      default: false,
      required: false,
    },
    block: {
      type: Boolean,
      default: false,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    to: {
      type: Object,
      default: () => {},
      required: false,
    },
    isAdd: {
      type: Boolean,
      default: false,
      required: false,
    },
    height: {
      type: String,
      default: 'auto',
      required: false,
    },
    small: {
      type: Boolean,
      default: false,
      required: false,
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters.isLoading || this.loading
    },
  },
  methods: {
    _onClick() {
      if (this.$validate.DataValid(this.to) && this.$validate.DataValid(this.to.name)) {
        this.$router.push(this.to)
      }
      this.$emit('click')
    },
  },
}
</script>
